<template>
  <v-row no-gutters class="pt-10 pb-5" justify="center">
    <v-col cols="12" lg="10" xl="8">
      <v-row no-gutters align="center" class="pb-4">
        <v-col>
          <h3>Tipologie di Garanzia</h3>
        </v-col>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                fab
                depressed
                dark
                small
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>Aggiungi</span>
        </v-tooltip>
      </v-row>
      <v-row no-gutters class="white bra align-start pa-3">
        <v-data-table
            :headers="headers"
            :items="items"
            item-key="title"
            class="pa-3 pt-0 pb-0"
            no-data-text="Nessun dato disponibile"
            :loading="loading"
            loading-text="Caricamento in corso..."
        >
          <template v-slot:item.actions="{ item }">
            <v-btn icon @click="edit(item)">
              <v-icon small class="mr-2 ml-2">
                mdi-pencil
              </v-icon>
            </v-btn>
            <action-confirm @method="del(item.id)" icon="mdi-delete" text="Stai per eliminare definitivamente la tipologia di garanzia selezionata. Confermando non potrà essere più recuperata."></action-confirm>
          </template>
        </v-data-table>
      </v-row>
    </v-col>
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="grey lighten-2 pt-2">
          <span v-if="!item.edit">Aggiungi Tipologia</span>
          <span v-else>Modifica Tipologia</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row no-gutters>
            <v-col cols="12" class="pa-3 pt-0">
              <span class="label">Nome</span>
              <input class="input" v-model="item.title">
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
              color="error"
              text
              @click="clean"
          >
            Annulla
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="store">
            <span v-if="!loading">Conferma</span>
            <v-progress-circular
                v-else
                indeterminate
                color="primary"
                :size="20"
                :width="2"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { db } from "@/main";
import firebase from 'firebase';
import ActionConfirm from '@/components/actions/confirm'
// @ is an alias to /src
export default {
  name: 'home',
  components: {ActionConfirm},
  methods: {
    get() {
      this.loading = true
      db.collection("guarantees").orderBy('title', "asc").get().then((data) => {
        data.forEach(elm => {
          let item = elm.data()
          item.id = elm.id
          this.items.push(item)
        })
        this.loading = false
      })
    },
    edit(elm) {
      this.item = {
        id: elm.id,
        title: elm.title,
        edit: true
      }
      this.dialog = true
    },
    store() {
      this.loading = true
      if(this.item.edit) {
        db.collection('guarantees').doc(this.item.id).update({
          "updated_at": firebase.firestore.Timestamp.now(),
          "title": this.item.title,
        }).then(() => {
          let index = this.items.findIndex(x => x.id ===this.item.id)
          this.items.splice(index,1)
          this.items.unshift(this.item)
          this.clean()
        })
      } else {
        db.collection('guarantees').add({
          "created_at": firebase.firestore.Timestamp.now(),
          "updated_at": firebase.firestore.Timestamp.now(),
          "title": this.item.title,
        }).then((res) => {
          this.items.unshift({
            "id": res.id,
            "title": this.item.title,
          })
          this.clean()
        })
      }
    },
    del(id) {
      db.collection("guarantees").doc(id).delete().then(() => {
        this.items.splice(this.items.findIndex(x => x.id === id), 1);
      })
    },
    clean() {
      this.dialog = false
      this.loading = false
      this.item = {
        title: null,
        edit: false
      }
    }
  },
  mounted () {
    // Binding Collections
    this.get()
  },
  data: () => ({
    dialog: false,
    headers: [
      { text: 'Azioni', value: 'actions', sortable: false, align: 'center' },
      { text: 'Nome', align: 'start', sortable: false, value: 'title'},
    ],
    items: [],
    loading: true,
    item: {
      title: null,
      edit: false
    }
  }),
}
</script>
